<template>
  <div
    class="flex-stepper panel panel-body"
    style="flex: 0 0 auto"
  >
    <general-stepper
      :steps-info="stepsInfo"
      :enable-save-button="enableSaveButton"
      @finish="saveSubscribables"
      @changeStep="changeStep"
    >
      <!--contents step-->
      <template
        slot="content-step-1"
        class="col-xs-12"
      >
        <div class="col-xs-12">
          <p>{{ trans('subscription.eventseries.explanation_create') }}</p>
        </div>

        <select-lessons
          @canFinishStep="finishStep(1)"
          @canNotFinishStep="notFinishStep(1)"
        />
      </template>

      <template
        slot="content-step-2"
        class="col-xs-12"
      >
        <create-event-series
          @canFinishStep="finishStep(2)"
          @canNotFinishStep="notFinishStep(2)"
        />
      </template>

      <template
        slot="content-step-3"
        class="col-xs-12"
      >
        <subscribables
          :errors="errors"
          @canFinishStep="finishStep(3)"
          @canNotFinishStep="notFinishStep(3)"
        />
      </template>
    </general-stepper>
  </div>
</template>

<script>
import SelectLessons from '../EventSeriesPreview/SelectLessons.vue'
import CreateEventSeries from './CreateEventSeries.vue'
import Subscribables from './Subscribables.vue'
import toast from '../../../services/toast'
import { defaultErrorMessage } from '@/helpers'

export default {

  name: 'EventSerieSubscribablesSteps',
  components: { SelectLessons, CreateEventSeries, Subscribables },

  data () {
    return {
      errors: null,
      enableSaveButton: false,
    }
  },

  computed: {
    stepsInfo () {
      return this.$store.state.steps.steps_info
    },

    courses () {
      return this.$store.state.eventSeries.courses
    },
    subscribables () {
      return this.$store.state.eventSerieSubscribables.subscribables
    },
    cluster_type () {
      return this.$store.state.eventSerieSubscribables.cluster_type
    },
  },

  created () {
    let stepsInfo = {
      1: {
        step: 1,
        lessonSelector: true,
        title: Lang.get('series.titles.select_lessons'),
        finished: false,
      },
      2: {
        step: 2,
        lessonSelector: false,
        title: Lang.get('subscription.eventseries.series'),
        finished: false,
      },
      3: {
        step: 3,
        lessonSelector: false,
        title: Lang.get('subscription.eventseries.parameters'),
        finished: false,
      },
    }
    this.$store.dispatch('add_steps_info', stepsInfo)
    this.$store.dispatch('set_active_step', { step: stepsInfo[1] })
    this.$store.dispatch('update_serie_rules', { rule: 'allow_shopping', value: true })
  },

  methods: {
    changeStep (event) {
      this.$store.dispatch('set_active_step', { step: event.step })
    },

    finishStep (stepNumber) {
      return this.$store.dispatch('update_step_finished', { step: stepNumber, finished: true })
    },

    notFinishStep (stepNumber) {
      return this.$store.dispatch('update_step_finished', { step: stepNumber, finished: false })
    },

    saveSubscribables () {
      this.errors = null
      axios.post('/admin/eventserie-subscribables', {
        course_information: this.courses,
        subscribables: this.subscribables,
        type: this.cluster_type,
        serie_rules: this.$store.state.eventSeries.serie_rules,
        count: this.$store.state.eventSerieSubscribables.count,
        type_format: this.$store.state.eventSerieSubscribables.type_format,
      }, { errorHandle: false }).then(response => {
        if ('redirect' in response.data) {
          window.location.href = response.data.redirect
        } else {
          toast.success(response.data.message)
        }
      }).catch(error => {
        this.errors = []
        Object.values(error.response.data).forEach(array => {
          array.forEach(string => {
            this.errors.push(string)
          })
        })

        this.enableSaveButton = !this.enableSaveButton

        defaultErrorMessage(error)
      })
    },
  },
}
</script>

<style>
    .flex-stepper {
        flex: 1 1 auto;
        overflow: auto;
    }

    .v-stepper {
        margin-bottom: 15px;
    }
</style>
